import { getFormattedCnpj } from "lib/data/formatters/CNPJ";
import { maskedTextFieldFactory } from "../maskedTextFieldFactory";

export const CNPJTextField = maskedTextFieldFactory(getFormattedCnpj);
